<template>
  <article id="app">
    <header class="app-header">
        <router-link to="/">
          <img width="180" src="./assets/brand_logo_1.png" alt="">
        </router-link>
        <div class="app-header-right">
          <img width="150" src="./assets/brand_logo_2.png" alt="">
        </div>
    </header>
    <section class="app-content section">
      <div class="container">
        <transition name="fade" mode="out-in">
          <router-view/>
        </transition>
      </div>
    </section>
    <footer class="footer">
      <div class="container">
        <div class="columns" style="justify-content:space-between">
          <div class="column is-6">
            <ul class="inline inline-start is-size-6">
              <li><a href="mailto:marketing@bigcity.in"><i class="fa fa-envelope"></i> feedback@bigcity.in</a></li>
              <li><a href="tel:91 80 4055 4844"><i class="fa fa-phone"></i> +91 80 4055 4844 </a></li>
            </ul>
          </div>
          <div class="column is-6">
            <ul class="inline  inline-end has-text-left-mobile has-text-right is-size-7">
              <li>Terms and Conditions</li>
              <li>Privacy Policy</li>
              <li>&copy; BigCity Promotions</li>
            </ul>
          </div>
        </div>
      </div>
    </footer>
  </article>
</template>

<script>
export default {
  name: "App"
};
</script>

<style lang="scss">
@import url("https://fonts.googleapis.com/css?family=Open+Sans:400,700");
@import url("https://fonts.googleapis.com/css?family=Anton");
@import url("https://fonts.googleapis.com/css?family=IBM+Plex+Sans+Condensed");

@import "~bulma/sass/utilities/initial-variables";

$body-font-family: "Open Sans";

// Variables
$brand-blue: #0068b3;
$brand-red: #db2559;
$brand-yellow: #ffc900;

$red: $brand-red;
$yellow: $brand-yellow;

// button
$button-color: $brand-blue;
$button-focus-color: $brand-blue;
$button-active-color: $brand-blue;
$button-hover-color: darken($brand-blue, 5%);
$button-background-color: $brand-yellow;
// footer
$footer-background-color: black;

@import "~bulma";

.inline {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  @media screen and (min-width: 420px) {
    flex-flow: row nowrap;
    justify-content: flex-end;
    li {
      padding-right: 1rem;
    }
  }
}

.button.is-warning {
  color: $brand-blue;
}

.app-header-right {
  padding: 0 1.75rem 0;
}

html,
body {
  height: 100%;
  background: $brand-blue;
}

body {
  background-image: url("./assets/bg_pattern.png");
  background-repeat: no-repeat;
  background-size: contain;
  background-position: 100%;
  color: white;
  font-family: $body-font-family;
}

.app-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.is-size-jumbo {
  font-size: 32px;
  @media screen and (min-width: 420px) {
    font-size: 4rem;
    line-height: 4.4rem;
  }
}

#app {
  display: flex;
  flex-flow: column nowrap;
  min-height: 100vh;
}

.app-content {
  flex: 1;
}

.button {
  border: 0;
}

.footer {
  padding: 2rem;
  a {
    color: white;
  }
}

.button {
  font-weight: bold;
  &.is-danger {
    &:hover,
    &:focus,
    &:active {
      color: white;
    }
  }
}

.box.is-danger {
  background-color: $red;
  color: white;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.inline-start {
  justify-content: flex-start;
}
.inline-end {
  justify-content: flex-end;
}
</style>




// WEBPACK FOOTER //
// src/App.vue